export enum LocalStorageKey {
  Logo = 'logo_url',
  Title_en = 'title_en',
  Title_ko = 'title_ko',
  Background = 'background_url',
}



// WEBPACK FOOTER //
// ./src/app/dashboard/enums/local-storage-key.enum.ts